import * as React from 'react'
import type {SVGProps} from 'react'
const SvgInstagram = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 18 18" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M12.375 0A5.626 5.626 0 0 1 18 5.625v6.75A5.626 5.626 0 0 1 12.375 18h-6.75A5.626 5.626 0 0 1 0 12.375v-6.75A5.626 5.626 0 0 1 5.625 0zm0 1.688h-6.75a3.94 3.94 0 0 0-3.938 3.937v6.75a3.943 3.943 0 0 0 3.938 3.938h6.75a3.943 3.943 0 0 0 3.938-3.938v-6.75a3.943 3.943 0 0 0-3.938-3.938zM9 4.285a4.714 4.714 0 1 1 0 9.428 4.714 4.714 0 0 1 0-9.428m0 1.768a2.95 2.95 0 0 0-2.946 2.946c0 1.624 1.322 2.946 2.946 2.946S11.946 10.624 11.946 9A2.95 2.95 0 0 0 9 6.054zm5.143-2.625a.428.428 0 1 1 0 .858.428.428 0 0 1 0-.858"
        />
    </svg>
)
export default SvgInstagram
